import { AssetsPath, BrandedAssetsPath, isVonageBrand } from '@/constants';

function getUrlFromString(url: string, regex: RegExp) {
  const match = regex.exec(url);
  return match && match.groups && match.groups.url;
}

const AbsoluteUrlRegex = /^\/?(?<url>(?:[a-z+]+:)?\/\/.*)$/i;
export const isAbsoluteUrl = (url: string) => AbsoluteUrlRegex.test(url);
export const getAbsoluteUrl = (url: string) => getUrlFromString(url, AbsoluteUrlRegex);

const MailToUrlRegex = /^\/?(?<url>mailto:(?:[^\\?]*))$/i;
export const isMailToUrl = (url: string) => MailToUrlRegex.test(url);
export const getMailtoUrl = (url: string) => getUrlFromString(url, MailToUrlRegex);

export const isRelativeUrl = (url: string) => !(isAbsoluteUrl(url) || isMailToUrl(url));

/**
 * Get external url from route as the vue router does not know
 * how to resolve them correctly.
 */
export const getExternalUrlFromPath = (path: string) => getAbsoluteUrl(path) || getMailtoUrl(path);

export const getFullPathForPublicAssets = (relativePath: string) => AssetsPath + relativePath;

export const getFullPathForBrandedAssets = (relativePath: string) => BrandedAssetsPath + relativePath;

export const getUrlForCurrenPage = () =>
  `${window.location.protocol}//${window.location.host}${window.location.pathname}`;

export const DUMMY_DOMAIN = 'https://dummydomain.com';

const removeTrailingSlash = (url: string) => url.replace(/\/$/, '');

export function stripURLTrailingSlash(url: string): string {
  // Need to add dummyDomain as it gives error of invalid urls for relative urls.
  const parsedUrl = new URL(url, DUMMY_DOMAIN);

  // Remove trailing slash from the pathname
  parsedUrl.pathname = removeTrailingSlash(parsedUrl.pathname);

  return removeTrailingSlash(parsedUrl.href.replace(DUMMY_DOMAIN, ''));
}
export const showCommunityLink = (link: string) => !(!isVonageBrand && link.includes('/community'));

export const showPricingLink = (link: string) =>
  !(!isVonageBrand && (link.includes('/pricing') || link.includes('#pricing')));
